import type { ComposerPayloadPollOptionsItem } from './composerPayloadPollOptionsItem';

export type ComposerPayloadPoll = {
  /**
   * @minimum 5
   * @maximum 10080
   */
  durationMinutes?: number;
  options?: ComposerPayloadPollOptionsItem[];
};
